<div class="login-container">
  <div class="login-form">
    <div class="logo">
      <img src="assets/img/KeyFigures_Logo.svg" alt="logo">
    </div>
    <div class="login-form-container">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="title">LOGIN TO YOUR ACCOUNT</div>
        <mat-error *ngIf="loginInvalid">
          {{ "login.errors.auth" | translate }}
        </mat-error>
        <mat-error *ngIf="error">
          {{ error }}
        </mat-error>
        <div class="mat-form-field-flex">
          <mat-form-field class="mat-form-field-infix" appearance="legacy">
            <mat-label>Email</mat-label>
            <input matInput formControlName="username" required>
            <mat-icon class="material-icons-outlined" matSuffix>email</mat-icon>
            <mat-error>
              {{ "errors.email" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="mat-form-field-flex">
          <mat-form-field class="mat-form-field-infix" appearance="legacy">
            <mat-label>Password</mat-label>
            <mat-icon class="material-icons-outlined" matSuffix>vpn_key</mat-icon>
            <input matInput type="password" formControlName="password" required>
            <mat-error>
              {{ "login.errors.password" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="remember-forgot-password" fxlayout="row" fxlayout.xs="column" fxlayoutalign="space-between center">
          <a class="forgot-password" href="https://www.extranet.weee-forum.org/forgot-password"> Forgot
            Password? </a></div>
        <button [disabled]="form.invalid" mat-raised-button color="primary">LOGIN</button>
      </form>
    </div>
  </div>
</div>

